import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';

export const Container = styled(FlexContainer)`
  gap: ${({ theme: { sizing } }) => sizing.fds_size_16};
  flex-wrap: wrap;
`;
